import { Modal, Input, Form, Row, Col, Avatar, Table, Divider } from 'antd'
import React, { useState } from 'react'
import { ButtonEx } from '../../../../styles/button.style'
import _, { isNull } from 'lodash'
import { isEmpty } from 'lodash'
import { useDeepEffect } from '../../../../utils/hooks'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment';
import {
  getHeroContract,
  saveHeroContract
} from '../../../../modules/hero'

const LogContract = (props) => {
  const dispatch = useDispatch()
  const { visible, onCancel, formData, form } = props
  const { setFieldsValue, getFieldDecorator, validateFields } = form

  const { heroLogContract, isLoading } = useSelector(
    (state) => ({
      isLoading: state.hero.isLoading,
      heroLogContract: state.hero.heroLogContract
    }),
    []
  )
  async function fetch() {
    await dispatch(getHeroContract(formData.id))
  }

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      fetch()
    }
  }, [formData])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          note: values.note
        }
        if (!_.isEmpty(formData)) {
          data.heroId = formData.id
        }
        await dispatch(saveHeroContract(data))
        setFieldsValue({
          note: '',
        })
        fetch()
      }
    })
  }

  const GetDate = (created) => {
    let date = ''
    if (created !== null) {
      date = moment(created).add(543, 'years').format('DD/MM/YYYY HH:mm')
    }
    return date
  }

  const columns = [
    {
      dataIndex: 'createdAt',
      key: 'createdAt',
      width: 200,
      render: (createdAt) => {
        const created = GetDate(createdAt)
        return (
          <span>
            เวลา {created}
          </span>
        )
      }
    },
    {
      dataIndex: 'note',
      key: 'note'
    },
    {
      dataIndex: 'adminName',
      key: 'adminName',
      width: 120,
      render: (name, record) => (
        <Row type="flex" gutter={8}>
          <Col>
            <div>
              <Avatar src={record.adminImage} />
            </div>
          </Col>
          <Col>
            <span>{name}</span>
          </Col>
        </Row>
      )
    },
  ]
  return (
    <Modal
      width={1000}
      title={`ประวัติการติดต่อ ${formData.name} `}
      visible={visible}
      onCancel={onCancel}
      footer={null}
    >
      {!isEmpty(heroLogContract) ?
        <Table
          loading={isLoading}
          dataSource={heroLogContract}
          columns={columns}
          size="small"
          showHeader={false}
        />
        : "ไม่มีประวัติการติดต่อ"}
      <div><br></br></div>
      <Form onSubmit={onSubmit}>
        <Form.Item>
          {getFieldDecorator(`note`, {
            rules: [
              {
                required: true,
                message: 'กรุณาเลือก'
              }
            ]
          })(
            <Input.TextArea autoSize={{ minRows: 3 }} />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="center">
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
              บันทึก
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedLogContract = Form.create({
  name: 'LogContract'
})(LogContract)
export default (WrappedLogContract)
